module.exports = __webpack_public_path__ + "img/Profil_TailWing_II_Compact_sliding.871511d5.jpg";